import * as Comlink from "comlink";
import { EventTypes } from "./BaseWorker";
import type { ExportWorker } from "./ExportWorker";

const workers: Map<string, Comlink.Remote<ExportWorker>> = new Map();

export async function addExportWorker(id: string, data: unknown = {}) {
  const uuid = id;
  if (!workers.has(uuid)) {
    const worker = new Worker(new URL("./ExportWorker.ts", import.meta.url), { type: "module" });
    worker.onmessage = (e) => {
      if (e.data.type?.toLowerCase() === "event") dispatchCustomEvent(e.data.eventType, e.data.data);
    };
    const DataExportWorkerInstance = Comlink.wrap<typeof ExportWorker>(worker);

    workers.set(uuid, await new DataExportWorkerInstance(id, data));
    console.log("[WORKER] created worker: ", uuid);

    dispatchCustomEvent(`${uuid}_${EventTypes.WorkerAvailable}`);
  }
}

export function removeExportWorker(uuid: string) {
  const currentWorker = workers.get(uuid);
  if (currentWorker) {
    currentWorker.terminate();
    workers.delete(uuid);
    console.log("[WORKER] worker was terminated", uuid);
  }
}

export function getExportWorkerByUUID(uuid: string) {
  return workers.get(uuid);
}

export function dispatchCustomEvent(eventType: string, value: unknown = null) {
  console.log("[WORKER] Dispatching Event: ", eventType, value);
  const event = new CustomEvent(eventType, { detail: value });

  document.dispatchEvent(event);
}
